import { Component, Vue } from 'vue-property-decorator'

//components
import PrivateContent from '@/components/privateContent/PrivateContent.vue'

//molds
import { Form } from '@/components/wrappers/molds/Form';
import { Process } from '@/store/modules/process/process';
import { TableOptions, WolfApiData } from '@/components/wrappers/molds/TableOptions';

//utils
import { convertDataPtBr, convertToParameterQuery, isEmpty } from '@/utils';

//services
import { Alert } from '@/services/notification';
import { ProcessService } from '@/services/processService';

//Vuex
const npProcess = 'process';
import { Action, Getter } from 'vuex-class';

//wrappers
import { 
	Box,
  WHr,
	WForm, 
	Loader,
	WTable,
  WButton,
	SizedBox,
	Container, 
	WSubtitle,
} from '@/components/wrappers';

@Component({
	components: {
		WHr,
		Box,
		WForm,
		WTable,
		Loader,
		WButton,
		SizedBox,
		Container,
		WSubtitle,
		PrivateContent,
	}
})
export default class SearchProcess extends Vue {

	//@Action('searchProcess', { namespace: npProcess }) searchProcess: any;
	
	// @Getter('wolfApiProcess', { namespace: npProcess }) wolfApiProcess!: WolfApiData;
	@Getter('error', { namespace: npProcess }) error!: any;

	//TODO deprecated
	isSearch = false
	
	//TODO deprecated
	result!: WolfApiData
	
	isLoading = true
	wolfApiData!: any

	//TODO deprecated
	alert = new Alert(this.$store)

	perPage = 20
	showTable = false
	paramQuery!: string

	processService = new ProcessService(this.$store)

	mounted(){
		document.title = 'Pesquisar Processos'
	}

	changePage(page: number): void {
		let _page = `_page=${page}`
		if(this.paramQuery != "?"){
			_page = '&'+_page
		}
		this.searchProcess(`${this.paramQuery}${_page}`)
	}

	async dispatchForm(input: any): Promise<void> {
		input = this.processService.convertNumYear(input)
		this.paramQuery = convertToParameterQuery(input)		
		this.searchProcess(this.paramQuery)
	}

	async searchProcess(query: string): Promise<void> {
		this.isLoading = true
		this.paramQuery = query
		
		await this.processService.dispatchSearchProcess(`${query}&_limit=${this.perPage}`).then((response) => {
			if(response){				
				this.wolfApiData = response;

				if(this.wolfApiData.list.length == 0){
					this.alert.warning("Nenhum processo encontrado")
				}else{
					window.scroll({
						top: 700,
						behavior: 'smooth'
					});
				}
			}
		})
		this.isLoading = false
	}

	tableSelected(process: Process){
		console.log(process);
	}

	startTable(): void {
		this.showTable = true
	}
	// não é parametro query devido a conversão num/ano
	get form(): Form {
		return {
			flex: false,
			indent: true,
			convertDate: true,
			grid: [
				[
					{
						fieldName: "numYear",
						type: "text",
						label: "Número/Ano",
						placeholder:"1/2019",
						maxlength: 30,
					},
					{
						fieldName: "subject",
						type: "text",
						placeholder:"Assunto",
						label: "Assunto",
						maxlength: 30,
						like: true
					},
					{
						fieldName: "dateTimeOpened",
						type: "date",
						label: "Data de Abertura",
						maxlength: 10
					},
				],
				[
					{
						fieldName: "userOrigin",
						type: "text",
						label: "Usuário de Origem",
						placeholder:"Usuário de Origem",
						maxlength: 50,
						like: true
					},
					{
						fieldName: "groupOrigin",
						type: "text",
						label: "Grupo de Origem",
						placeholder:"Grupo Origem",
						maxlength: 30,
						like: true
					},
					{
						fieldName: "groupDestiny",
						type: "text",
						label: "Grupo de Destino",
						placeholder:"Grupo de Destino",
						maxlength: 100,
						like: true
					},
				],
				[
					{
						fieldName: "details",
						type: "text",
						label: "Detalhes",
						placeholder:"Detalhes",
						maxlength: 100,
						like: true
					},
					{
						fieldName: "status",
						label: "Status",
						type: "select",
						maxlength: 11,
						value: "",
						options:[
							{
								label: "Selecione ...",
								value: ""
							},
							{
								label: "Desativado",
								value: "0"
							},
							{
								label: "Arquivado",
								value: "1"
							},
							{
								label: "Encaminhado",
								value: "2"
							},
							{
								label: "Recebido",
								value: "3"
							},
							{
								label: "Atrasado",
								value: "4"
							},
							{
								label: "Finalizado",
								value: "5"
							},
						]
					},
				],
			]
		}
	}

	//############# Table ##############
	get	table(): TableOptions | null {
		if(this.isLoading){
			return null
		}
		return {	
			paginated: true,
			perPage: this.perPage,
			wolfApiData: this.wolfApiData,
			columns: [
				{
					field: 'num',
					label: 'Número',
					sortable: true,
				},
				{
					field: 'year',
					label: 'Ano',
					sortable: true
				},
				{
					field: 'subject',
					label: 'Assunto',
					sortable: true
				},
				{
					field: 'dateTimeOpened',
					label: 'Data de Abertura',
					sortable: true
				},
				{
					field: 'userOrigin',
					label: 'Usuário de origem',
					sortable: true
				},
				{
					field: 'groupOrigin',
					label: 'Grupo de Origem',
					sortable: true
				},
				{
					field: 'groupDestiny',
					label: 'Grupo de Destino',
					sortable: true
				},
				{
					field: 'details',
					label: 'Detalhes',
					sortable: true
				},
				{
					field: 'status',
					label: 'Status',
					sortable: true
				},
			]
		}
	}


}
